import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-138b64ee"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["for"];
const _hoisted_2 = ["id", "value"];
const _hoisted_3 = { key: 1 };
import { ExclamationIcon } from "@heroicons/vue/solid";
import { computed, ref } from "vue";
import { v4 } from "uuid";
export default /*#__PURE__*/ _defineComponent({
    props: {
        label: { default: "" },
        errors: null,
        modelValue: null
    },
    emits: ["update:modelValue"],
    setup(__props, { emit }) {
        const props = __props;
        const hasErrors = computed(() => (props.errors && props.errors.length > 0) ?? false);
        const input = ref();
        const uuid = v4();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                    'form-input',
                    _ctx.$attrs.type === 'hidden' ? 'form-input--hidden' : '',
                    _unref(hasErrors) ? 'form-input--error' : undefined,
                ].join(' '))
            }, [
                (_ctx.$slots['label'] || props.label.length)
                    ? _renderSlot(_ctx.$slots, "label", {
                        key: 0,
                        forId: _unref(uuid)
                    }, () => [
                        _createElementVNode("label", {
                            class: "form-input__label",
                            for: _unref(uuid)
                        }, _toDisplayString(props?.label), 9, _hoisted_1)
                    ])
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: "form-input__inner flex",
                    onClickPassive: _cache[1] || (_cache[1] = ($event) => (input.value.focus()))
                }, [
                    (_ctx.$slots['icon'])
                        ? _renderSlot(_ctx.$slots, "icon", { key: 0 })
                        : _createCommentVNode("", true),
                    _createElementVNode("input", _mergeProps({
                        onInputPassive: _cache[0] || (_cache[0] = ($event) => (emit('update:modelValue', $event.target.value)))
                    }, _ctx.$attrs, {
                        ref_key: "input",
                        ref: input,
                        id: _unref(uuid),
                        value: props.modelValue
                    }), null, 16, _hoisted_2),
                    (_ctx.$slots['right'])
                        ? _renderSlot(_ctx.$slots, "right", {
                            key: 1,
                            class: "flex-none"
                        })
                        : _createCommentVNode("", true),
                    (_unref(hasErrors))
                        ? (_openBlock(), _createBlock(_unref(ExclamationIcon), { key: 2 }))
                        : _createCommentVNode("", true)
                ], 32),
                (_unref(hasErrors))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.errors.join(" ")), 1))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
